import { BehaviorSubject } from 'rxjs';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';

let _authenticated: BehaviorSubject<boolean> | null = null;

function getAuthenticatedSubject() {
  if (!_authenticated) {
    _authenticated = new BehaviorSubject<boolean>(false);
  }
  return _authenticated;
}

export function useAuth() {
  const subject = getAuthenticatedSubject();
  const isAuthenticated = useObservable(() => subject.asObservable());

  return {
    isAuthenticated,
    setAuthenticated: (value: boolean) => subject.next(value)
  };
}
